import type { PVValidationCheck } from "@/types";
import { ValidationCheckRow } from "./ValidationCheckRow";

interface StagePanelProps {
	checks: PVValidationCheck[];
}

const STATUS_ORDER: Record<string, number> = { fail: 0, warn: 1, pass: 2 };

function sortChecks(checks: PVValidationCheck[]): PVValidationCheck[] {
	return [...checks].sort(
		(a, b) =>
			(STATUS_ORDER[a.status] ?? 3) - (STATUS_ORDER[b.status] ?? 3),
	);
}

export function StagePanel({ checks }: StagePanelProps) {
	const counts = { pass: 0, warn: 0, fail: 0 };
	for (const check of checks) {
		counts[check.status]++;
	}

	const sorted = sortChecks(checks);

	return (
		<div className="space-y-3">
			<div className="flex items-center gap-4 text-sm">
				{counts.fail > 0 && (
					<span className="text-red-500 font-medium">
						{counts.fail} failed
					</span>
				)}
				{counts.warn > 0 && (
					<span className="text-yellow-500 font-medium">
						{counts.warn} warnings
					</span>
				)}
				{counts.pass > 0 && (
					<span className="text-green-500 font-medium">
						{counts.pass} passed
					</span>
				)}
			</div>

			<div className="space-y-2">
				{sorted.map((check) => (
					<ValidationCheckRow
						key={check.id}
						check={check}
						defaultExpanded={check.status === "fail"}
					/>
				))}
			</div>
		</div>
	);
}
